<template>
  <Popup
    class="temporary-registration-dialog"
    :value="value"
    :close-on-click-overlay="false"
    role="dialog"
    aria-modal="true"
    @input="handleVisibleChange"
  >
    <div class="registration-message text-16 leading-24 text-main">
      {{ message }}
    </div>
    <div class="guide-actions flex">
      <Button class="guide-button" type="primary" size="small" @click="handleViewGuide">
        查看操作说明
      </Button>
      <Button class="guide-button" type="default" size="small" plain @click="handleConfirm">
        知道了
      </Button>
    </div>
  </Popup>
</template>

<script>
import { Button, Popup } from 'vant';

export default {
  name: 'TemporaryRegistrationDialog',
  components: {
    Button,
    Popup
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '您还未完成税务活体认证，请下载“电子税务局”APP完成注册和活体认证!'
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    handleVisibleChange(visible) {
      this.$emit('input', visible);
    },
    handleConfirm() {
      this.close();
      this.$emit('confirm');
    },
    handleViewGuide() {
      this.close();
      this.$emit('view-guide');
    }
  }
};
</script>

<style lang="less" scoped>
.temporary-registration-dialog {
  width: 3.2rem;
  max-width: 90%;
  overflow: hidden;
  border-radius: 0.04rem;
}

.registration-message {
  padding: 0.2rem 0.48rem;
  text-align: left;
}

.guide-actions {
  padding: 0.08rem 0.48rem;
  border-top: 1px solid #eeeeee;
}

.guide-button {
  flex: 1;
  min-width: 0;
}

.guide-button + .guide-button {
  margin-left: 0.16rem;
}
</style>
